//LOGIN
export const LOGIN = "LOGIN";
export const LOGOUT = "LOGOUT";
export const REGISTER = "REGISTER";
export const REFRESHTOKEN = "REFRESHTOKEN";
export const VERIFY_EMAIL = "VERIFY_EMAIL";
export const VERIFY_MEMBER = "VERIFY_MEMBER";
export const COMPLETE_REGISTRATION = "COMPLETE_REGISTRATION";
export const RESEND_VERIFICATION_EMAIL = "RESEND_VERIFICATION_EMAIL";

//SWITCH ACCOUNT
export const SWITCH_ACCOOUNT = "SWITCH_ACCOOUNT";

//USER
export const EDIT_USER_DETAILS = "EDIT_USER_DETAILS";
export const EDIT_USER_SETTINGS = "EDIT_USER_SETTINGS";
export const EDIT_USER_PROFILE = "EDIT_USER_PROFILE";
export const CHANGE_USER_PASSWORD = "CHANGE_USER_PASSWORD";
export const UPLOAD_USER_ID = "UPLOAD_USER_ID";

//Account
export const LOAD_ACCOUNT = "LOAD_ACCOUNT";
export const EDIT_ACCOUNT_SETTINGS = "EDIT_ACCOUNT_SETTINGS";
export const PATCH_ACCOUNT_SETTINGS = "PATCH_ACCOUNT_SETTINGS";
export const UPDATE_INVOICE_FLAG = "UPDATE_INVOICE_FLAG";
// export const CREATE_ACCOUNT = "CREATE_ACCOUNT"

//PASSWORD RESET
export const SEND_PASSWORD_RESET_LINK = "SEND_PASSWORD_RESET_LINK";
export const VERIFY_RESET_PASSWORD_LINK = "VERIFY_RESET_PASSWORD_LINK";
export const RESET_PASSWORD = "RESET_PASSWORD";

//ORGANIZATION
export const LOAD_ORGANIZATION = "LOAD_ORGANIZATION";

//CURRENCIES
export const LOAD_CURRENCIES = "LOAD_CURRENCIES";

//ALERT
export const ADD_ALERT = "ADD_ALERT";

//LOADING
export const TOGGLE_LOADING = "TOGGLE_LOADING";

//PROJECTS
export const LOAD_ALL_PROJECT = "LOAD_ALL_PROJECT";
export const SAVE_PROJECT = "SAVE_PROJECT";
export const UPDATE_PROJECT = "UPDATE_PROJECT";
export const UPGRADE_SUBSCRIPTION = "UPGRADE_SUBSCRIPTION";
export const START_PROJECT = "START_PROJECT";
export const STOP_PROJECT = "STOP_PROJECT";
export const TERMINATE_PROJECT = "TERMINATE_PROJECT";
export const LOAD_PROJECT_BY_ID = "LOAD_PROJECT_BY_ID";
export const LOAD_PROJECT_COST = "LOAD_PROJECT_COST";
export const LOAD_ALL_CREDENTIAL = "LOAD_ALL_CREDENTIAL";
export const GET_GUEST_LINKS = "GET_GUEST_LINKS";
export const GET_GUEST_LINKS_USERS = "GET_GUEST_LINKS_USERS";
export const RESET_GUEST_LINK_USER_PASSWORD = "RESET_GUEST_LINK_USER_PASSWORD";
export const UPDATE_PROJECT_DIRECT_LINK_ACCESS_TYPE = "UPDATE_PROJECT_DIRECT_LINK_ACCESS_TYPE";
export const CREATE_GUEST_LINK = "CREATE_GUEST_LINK";
export const UPDATE_GUEST_LINK = "UPDATE_GUEST_LINK";
export const SAVE_CREDENTIAL = "SAVE_CREDENTIAL";
export const UPDATE_CREDENTIAL = "UPDATE_CREDENTIAL";
export const CREATE_IP_ACCESS = "CREATE_IP_ACCESS";
export const GET_ALL_IP_ACCESS = "GET_ALL_IP_ACCESS";
export const UPDATE_IP_ACCESS = "UPDATE_IP_ACCESS";
export const DELETE_IP_ACCESS = "DELETE_IP_ACCESS";
export const SEND_UPGRADE_SUBSCRIPTION_REQUEST = "SEND_UPGRADE_SUBSCRIPTION_REQUEST";
export const LOAD_PROJECT_COUNTS = "LOAD_PROJECT_COUNTS";
export const GENERATE_FILE = "GENERATE_FILE";
export const GENERATE_CONVERSATION_HISTORY = "GENERATE_CONVERSATION_HISTORY";
export const FETCH_PROFILE_CONVERSATION_INSIGHTS = "FETCH_PROFILE_CONVERSATION_INSIGHTS";
export const REINDEX_PROJECT = "REINDEX_PROJECT";
export const GENERATE_SESSION_HISTORY = "GENERATE_SESSION_HISTORY";
export const GENERATE_MAIRA_QUESTIONNAIRE_HISTORY = "GENERATE_MAIRA_QUESTIONNAIRE_HISTORY";
export const GENERATE_QUESTIONNAIRE_LOGS = "GENERATE_QUESTIONNAIRE_LOGS";
export const SET_PROJECT_ROLE = "SET_PROJECT_ROLE";

//Project Members Assignment
export const ASSIGN_PROJECT_MEMBERS = "ASSIGN_PROJECT_MEMBERS";
export const RETRIEVE_PROJECT_MEMBERS = "RETRIEVE_PROJECT_MEMBERS";
export const DELETE_PROJECT_MEMBERS = "DELETE_PROJECT_MEMBERS";
export const UPDATE_PROJECT_MEMBERS = "UPDATE_PROJECT_MEMBERS";

export const GENERATE_PUBLIC_INVITATION_URL = "GENERATE_PUBLIC_INVITATION_URL";
export const UPDATE_PUBLIC_INVITATION_URL = "UPDATE_PUBLIC_INVITATION_URL";
export const GET_PUBLIC_INVITATIONS_LIST = "GET_PUBLIC_INVITATIONS_LIST";

export const INVITE_GUEST_USERS = "INVITE_GUEST_USERS";
export const UPDATE_GUEST_USERS = "UPDATE_GUEST_USERS";

export const GET_MAIRA_OPTIONS = "GET_MAIRA_OPTIONS";
export const UPDATE_MAIRA_OPTIONS = "UPDATE_MAIRA_OPTIONS";

// ALLOWED IPS
export const GET_ALL_ALLOWED_IPS = "GET_ALL_ALLOWED_IPS";
export const CREATE_ALLOWED_IP = "CREATE_ALLOWED_IP";
export const GET_ALLOWED_IP_BY_ID = "GET_ALLOWED_IP_BY_ID";
export const UPDATE_ALLOWED_IP = "UPDATE_ALLOWED_IP";
export const DELETE_ALLOWED_IP = "DELETE_ALLOWED_IP";

//GAIP to RECOMMENDER
export const GET_RANK_SETTINGS = "GET_RANK_SETTINGS";
export const UPDATE_RANK_SETTINGS = "UPDATE_RANK_SETTINGS";
export const GET_MAPPER = "GET_MAPPER";
export const CREATE_MAPPER = "CREATE_MAPPER";
export const UPDATE_MAPPER = "UPDATE_MAPPER";
export const GET_INDICES = "GET_INDICES";
export const CREATE_INDICES = "CREATE_INDICES";
export const CREATE_RANK = "CREATE_RANK";
export const UPLOAD_RECOMMENDER_DATA = "UPLOAD_RECOMMENDER_DATA";
export const ITEMS_TRAIN = "ITEMS_TRAIN";
export const IMAGES_TRAIN = "IMAGES_TRAIN";
export const RANKS_TRAIN = "RANKS_TRAIN";
export const GET_TASKS_STATUS = "GET_TASKS_STATUS";
export const DB_STORE_TASKS_STATUS = "DB_STORE_TASKS_STATUS";
export const DB_GET_TASKS_STATUS = "DB_GET_TASKS_STATUS";
export const LOAD_TRAIN_TASKS = "LOAD_TRAIN_TASKS";
export const GET_PREVIOUSLY_SETUP_STATE = "GET_PREVIOUSLY_SETUP_STATE";
export const GET_CATALOG_ITEMS = "GET_CATALOG_ITEMS";
export const REMOVE_CATALOG_ITEMS = "REMOVE_CATALOG_ITEMS";
export const UPDATE_CATALOG_ITEM = "UPDATE_CATALOG_ITEM";

//Email Config
export const LOAD_EMAIL_CONFIGS = "LOAD_EMAIL_CONFIGS";
export const LOAD_EMAIL_PROVIDERS = "LOAD_EMAIL_PROVIDERS";
export const INITIATE_OAUTH_LOGIN = "INITIATE_OAUTH_LOGIN";
export const SAVE_SMTP_CONFIG = "SAVE_SMTP_CONFIG";
export const DELETE_EMAIL_CONFIG = "DELETE_EMAIL_CONFIG";
export const UPDATE_EMAIL_CONFIG_STATUS = "UPDATE_EMAIL_CONFIG_STATUS";

//Email Recipients
export const LOAD_EMAIL_RECIPIENTS = "LOAD_EMAIL_RECIPIENTS";
export const SAVE_EMAIL_RECIPIENT = "SAVE_EMAIL_RECIPIENT";
export const UPDATE_EMAIL_RECIPIENT = "UPDATE_EMAIL_RECIPIENT";
export const DELETE_EMAIL_RECIPIENT = "DELETE_EMAIL_RECIPIENT";
export const GET_EMAIL_RECIPIENT = "GET_EMAIL_RECIPIENT";

//Email Templates
export const LOAD_EMAIL_TEMPLATES = "LOAD_EMAIL_TEMPLATES";
export const SAVE_EMAIL_TEMPLATE = "SAVE_EMAIL_TEMPLATE";
export const UPDATE_EMAIL_TEMPLATE = "UPDATE_EMAIL_TEMPLATE";
export const DELETE_EMAIL_TEMPLATE = "DELETE_EMAIL_TEMPLATE";
export const GET_EMAIL_TEMPLATE = "GET_EMAIL_TEMPLATE";

//GPT Profile
export const GET_GPT_PROFILES = "GET_GPT_PROFILES";
export const GET_GPT_PROFILE_BY_ID = "GET_GPT_PROFILE_BY_ID";
export const CREATE_GPT_PROFILE = "CREATE_GPT_PROFILE";
export const UPDATE_GPT_PROFILE_STATE = "UPDATE_GPT_PROFILE_STATE";
export const UPDATE_GPT_PROFILE_API = "UPDATE_GPT_PROFILE_API";
export const DELETE_GPT_PROFILE = "DELETE_GPT_PROFILE";
export const FETCH_SHAREABLE_DATA = "FETCH_SHAREABLE_DATA";
export const GET_DEFAULT_CATEGORIES = "GET_DEFAULT_CATEGORIES";
export const ENCRYPT_EXTERNAL_SYSTEM_DATA = "ENCRYPT_EXTERNAL_SYSTEM_DATA";
export const GET_BROADCASTS_MESSAGE = "GET_BROADCASTS_MESSAGE";
export const CREATE_BROADCAST_MESSAGE = "CREATE_BROADCAST_MESSAGE";
export const UPDATE_BROADCAST_MESSAGE = "UPDATE_BROADCAST_MESSAGE";
export const DELETE_BROADCAST_MESSAGE = "DELETE_BROADCAST_MESSAGE";

//GPT Settings
export const CREATE_GPT_SETTINGS = "CREATE_GPT_SETTINGS";
export const GET_GPT_SETTINGS = "GET_GPT_SETTINGS";
export const DELETE_GPT_SETTINGS = "DELETE_GPT_SETTINGS";
export const UPDATE_GPT_SETTINGS = "UPDATE_GPT_SETTINGS";

//GPT Datasets
export const GET_GPT_DATASETS = "GET_GPT_DATASETS";
export const GET_GPT_DATASETS_SUMMARY = "GET_GPT_DATASETS_SUMMARY";
export const GET_GPT_DATASET_BY_ID = "GET_GPT_DATASET_BY_ID";
export const CREATE_GPT_DATASET = "CREATE_GPT_DATASET";
export const CREATE_GPT_DATASET_TS = "CREATE_GPT_DATASET_TS";
export const UPDATE_GPT_DATASET_API = "UPDATE_GPT_DATASET_API";
export const UPDATE_GPT_DATASET_FILE = "UPDATE_GPT_DATASET_FILE";
export const UPDATE_GPT_DATASET_TS_FILE = "UPDATE_GPT_DATASET_TS_FILE";
export const UPDATE_GPT_DATASET_STATE = "UPDATE_GPT_DATASET_STATE";
export const TERMINATE_GPT_DATASET = "TERMINATE_GPT_DATASET";

export const UPDATE_GPT_SETUP_STATE = "UPDATE_GPT_SETUP_STATE";
export const GET_COUNTRY_LIST = "GET_COUNTRY_LIST";

//GPT Tasks
export const GET_ALL_TASKS = "GET_ALL_TASKS";
export const GET_TASK_STATUS = "GET_TASK_STATUS";
export const GET_TASKS_BY_PREFIX = "GET_TASKS_BY_PREFIX";

//GPT Documents
export const GET_GPT_DOCUMENTS = "GET_GPT_DOCUMENTS";
export const GET_GPT_DOCUMENT_BY_ID = "GET_GPT_DOCUMENT_BY_ID";
export const CREATE_GPT_DOCUMENT = "CREATE_GPT_DOCUMENT";
export const UPDATE_GPT_DOCUMENT = "UPDATE_GPT_DOCUMENT";
export const TERMINATE_GPT_DOCUMENTS = "TERMINATE_GPT_DOCUMENTS";

//Train
export const TRAIN_GPT_DATASET = "TRAIN_GPT_DATASET";

export const RECOMMENDER_INSIGHTS = "RECOMMENDER_INSIGHTS";
export const RECOMMENDER_UPDATE_FEEDBACK = "RECOMMENDER_UPDATE_FEEDBACK";

//DATASET
export const LOAD_ALL_DATASETS = "LOAD_ALL_DATASETS";
export const CREATE_DATASET = "CREATE_DATASET";
export const UPLOAD_DATASET = "UPLOAD_DATASET";
export const ADD_CONVERSATION_TO_DATASET = "ADD_CONVERSATION_TO_DATASET";
export const DATASET_DOWNLOAD_REQUEST = "DATASET_DOWNLOAD_REQUEST";
export const GENERATE_PRESIGNED_URL = "GENERATE_PRESIGNED_URL";

//GPT Conversations
export const RETRIEVE_GPT_CONVERSATIONS = "RETRIEVE_GPT_CONVERSATIONS";
export const RETRIEVE_GPT_CONVERSATION_DETAIL = "RETRIEVE_GPT_CONVERSATION_DETAIL";

//SOLUTIONS
export const LOAD_ALL_SOLUTION = "LOAD_ALL_SOLUTION";
export const LOAD_ALL_SOLUTION_BY_TYPE = "LOAD_ALL_SOLUTION_BY_TYPE";
export const SAVE_SOLUTION = "SAVE_SOLUTION";
export const UPDATE_SOLUTION_BY_ID = "UPDATE_SOLUTION_BY_ID";
export const DELETE_SOLUTION = "DELETE_SOLUTION";
export const LOAD_SOLUTION_BY_ID = "LOAD_SOLUTION_BY_ID";
export const LOAD_RELATED_SOLUTIONS_BY_TYPE = "LOAD_RELATED_SOLUTIONS_BY_TYPE";
export const LOAD_ALL_SOLUTION_BY_DEV = "LOAD_ALL_SOLUTION_BY_DEV";
export const PUBLISH_SOLUTION_BY_ID = "PUBLISH_SOLUTION_BY_ID";
export const DRAFT_SOLUTION_BY_ID = "DRAFT_SOLUTION_BY_ID";
export const LOAD_DEV_SOLUTION_BY_TYPE = "LOAD_DEV_SOLUTION_BY_TYPE";
export const LOAD_PUBLIC_SOLUTIONS = "LOAD_PUBLIC_SOLUTIONS";
export const LOAD_SOLUTION_DETAILS = "LOAD_SOLUTION_DETAILS";
export const SOLUTION_HAS_PROJECT = "SOLUTION_HAS_PROJECT";
export const RESET_SOLUTION_HAS_PROJECT = "RESET_SOLUTION_HAS_PROJECT";
export const RESET_SELECTED_SOLUTION = "RESET_SELECTED_SOLUTION";

//REGION
export const LOAD_REGION_BY_CLOUD_PROVIDER = "LOAD_REGION_BY_CLOUD_PROVIDER";
export const LOAD_REGION_BY_ID = "LOAD_REGION_BY_ID";

//RESOURCEMETADATA
export const LOAD_ALL_RESOURCEMETADATA = "LOAD_ALL_RESOURCEMETADATA";
export const LOAD_RESOURCEMETADATA_BY_TYPE = "LOAD_RESOURCEMETADATA_BY_TYPE";

//CATEGORY
export const LOAD_ALL_CATEGORY = "LOAD_ALL_CATEGORY";
export const SAVE_CATEGORY = "SAVE_CATEGORY";

// SUBSCRIPTION
export const LOAD_ALL_SUBSCRIPTION = "LOAD_ALL_CATEGORY";
export const SAVE_SUBSCRIPTION = "SAVE_SUBSCRIPTION";
export const UPDATE_SUBSCRIPTION_FEE = "UPDATE_SUBSCRIPTION_FEE";

// INVOICES
export const LOAD_ALL_INVOICE = "LOAD_ALL_INVOICE";
export const LOAD_INVOICE_BY_ID = "LOAD_INVOICE_BY_ID";
export const PAY_INVOICE_BY_ID = "PAY_INVOICE_BY_ID";

// SEGMENT
export const LOAD_ALL_SEGMENT = "LOAD_ALL_SEGMENT";
export const SAVE_SEGMENT = "SAVE_SEGMENT";

// WALLET
export const CHECK_WALLET_PASSCODE = "CHECK_WALLET_PASSCODE";
export const REGISTER_WALLET_PASSCODE = "REGISTER_WALLET_PASSCODE";
export const ACCESS_WALLET = "ACCESS_WALLET";
export const WALLET_REVOKE = "WALLET_REVOKE";
export const LOAD_ACCOUNT_BALANCE = "LOAD_ACCOUNT_BALANCE";
export const CHECK_BALANCE = "CHECK_BALANCE";
export const ADD_WALLET_ACCOUNT = "ADD_WALLET_ACCOUNT";
export const LOAD_ALL_WALLET_ACCOUNT = "LOAD_ALL_WALLET_ACCOUNT";
export const WALLET_BUY_ASSET = "WALLET_BUY_ASSET";
export const BUY_AUTHORIZE = "BUY_AUTHORIZE";
export const LOAD_ALL_WALLET_TRANSACTION = "LOAD_ALL_WALLET_TRANSACTION";
export const GET_WALLET_ACCOUNT_DETAILS = "GET_WALLET_ACCOUNT_DETAILS";
export const WALLET_CREATE_ACCOUNT_FROM_SOURCE = "WALLET_CREATE_ACCOUNT_FROM_SOURCE";
export const WALLET_CREATE_ACCOUNT_WITHOUT_SOURCE = "WALLET_CREATE_ACCOUNT_WITHOUT_SOURCE";
export const WALLET_CHECK_QUOTE = "WALLET_CHECK_QUOTE";
export const WALLET_SWAP_ASSET = "WALLET_SWAP_ASSET";
export const WALLET_SEND_ASSET = "WALLET_SEND_ASSET";
export const GET_WALLET_TRANSACTION_DETAILS = "GET_WALLET_TRANSACTION_DETAILS";
export const GET_WALLET_SWAP_RATE = "GET_WALLET_SWAP_RATE";
export const EDIT_WALLET_ACCOUNT = "EDIT_WALLET_ACCOUNT";
export const REMOVE_WALLET_ACCOUNT = "REMOVE_WALLET_ACCOUNT";
export const GET_WALLET_TRANSACTION = "GET_WALLET_TRANSACTION";
export const GET_WALLET_CLAIMABLE_BALANCE = "GET_WALLET_CLAIMABLE_BALANCE";
export const WALLET_CLAIM_CLAIMABLE_BALANCE = "WALLET_CLAIM_CLAIMABLE_BALANCE";
export const GET_WALLET_CLAIMABLE_BALANCE_RECIEVED_HISTORY = "GET_WALLET_CLAIMABLE_BALANCE_RECIEVED_HISTORY";
export const WALLET_SECRET_KEY_SAVED_CONSENT = "WALLET_SECRET_KEY_SAVED_CONSENT";
export const LOAD_WALLET_BUY_HISTORY_BY_ACCOUNT = "LOAD_WALLET_BUY_HISTORY_BY_ACCOUNT";
export const LOAD_WALLET_REWARD_PERCENTAGES = "LOAD_WALLET_REWARD_PERCENTAGES";
export const LOAD_WALLET_APPLICABLE_REWARD_INFO = "LOAD_WALLET_APPLICABLE_REWARD_INFO";
export const WALLET_SHOW_SECRET_KEY = "WALLET_SHOW_SECRET_KEY";
export const LOAD_ALL_WALLET_ASSET = "LOAD_ALL_WALLET_ASSET";
export const UPDATE_WALLET_WYRE_ORDER = "UPDATE_WALLET_WYRE_ORDER";

// UPLOAD
export const SAVE_CONTENT = "SAVE_CONTENT";
export const LOAD_ALL_CONTENT = "LOAD_ALL_CONTENT";
export const LOAD_SINGLE_CONTENT = "LOAD_SINGLE_CONTENT";

// BANKS
export const LOAD_ALL_BANK_ACCOUNT = "LOAD_ALL_BANK_ACCOUNT";
export const LOAD_BANK_ACCOUNT_BY_ID = "LOAD_BANK_ACCOUNT_BY_ID";

// JOBS
export const LOAD_ALL_JOB = "LOAD_ALL_JOB";
export const RERUN_JOB_BY_ID = "RERUN_JOB_BY_ID";

// MEMBERS
export const LOAD_ALL_MEMBERS = "LOAD_ALL_MEMBERS";
export const LOAD_MEMBER_BY_ID = "LOAD_MEMBER_BY_ID";
export const SEND_MEMBER_RE_INVITATION = "SEND_MEMBER_RE_INVITATION";
export const SEND_MEMBER_INVITATION = "SEND_MEMBER_INVITATION";
export const UPDATE_MEMBER = "UPDATE_MEMBER";
export const MEMBER_SETUP = "MEMBER_SETUP";
export const FETCH_USER_STATUS = "FETCH_USER_STATUS";

// LOCALE
export const CHANGE_LOCALE = "CHANGE_LOCALE";

// ITEMS
export const GET_ITEMS_DETAILS_BY_IDS = "GET_ITEMS_DETAILS_BY_IDS";

//Recommend
export const FETCH_ITEMS_RECOMMEND = "FETCH_ITEMS_RECOMMEND";
export const FETCH_ITEMS_PURCHASED_TOGETHER = "FETCH_ITEMS_PURCHASED_TOGETHER";
export const FETCH_USERS_RECOMMEND = "FETCH_USERS_RECOMMEND";
export const FETCH_TRENDING_ITEMS = "FETCH_TRENDING_ITEMS";
export const IMAGE_ITEMS_RECOMMEND = "IMAGE_ITEMS_RECOMMEND";
export const USERS_SEARCH_RECOMMEND = "USERS_SEARCH_RECOMMEND";
export const QUESTIONNAIRES_LIST = "QUESTIONNAIRES_LIST";
export const QUESTIONNAIRE_DETAILS = "QUESTIONNAIRE_DETAILS";
export const QUESTIONNAIRE_RECOMMEND = "QUESTIONNAIRE_RECOMMEND";

// Search
export const ITEMS_SEARCH = "ITEMS_SEARCH";
export const IMAGES_SEARCH = "IMAGES_SEARCH";
export const USERS_KEYWORDS = "USERS_KEYWORDS";
export const CATEGORIES_KEYWORDS = "CATEGORIES_KEYWORDS";

// Questionnaire
export const GET_QUESTIONNAIRE_LOG = "GET_QUESTIONNAIRE_LOG";

//Settings
export const CREATE_SETTINGS = "CREATE_SETTINGS";
export const UPDATE_SETTINGS = "UPDATE_SETTINGS";
export const GET_SETTINGS = "GET_SETTINGS";

//gptModel
export const GET_GPT_MODELS = "GET_GPT_MODELS";
export const GET_GPT_MODEL_DETAILS = "GET_GPT_MODEL_DETAILS";

// GPT Session
export const GET_GPT_SESSIONS = "GET_GPT_SESSIONS";
export const UPDATE_GPT_SESSION = "UPDATE_GPT_SESSION";

export const GET_SESSION_COUNT_PER_PROFILE = "GET_SESSION_COUNT_PER_PROFILE";

// Maira Questionnaire
export const MAIRA_QUESTIONNAIRE = "MAIRA_QUESTIONNAIRE";
export const DELETE_MAIRA_QUESTIONNAIRE = "DELETE_MAIRA_QUESTIONNAIRE";
export const GET_MAIRA_QUESTIONNAIRE = "GET_MAIRA_QUESTIONNAIRE";
export const POST_MAIRA_QUESTIONNAIRE = "POST_MAIRA_QUESTIONNAIRE";
export const UPDATE_MAIRA_QUESTIONNAIRE = "UPDATE_MAIRA_QUESTIONNAIRE";
export const SET_QUESTIONNAIRE_MODE = "SET_QUESTIONNAIRE_MODE";
export const RESET_QUESTIONNAIRE_FORM = "RESET_QUESTIONNAIRE_FORM";

// Maira Questionnaire Responses
export const GET_QUESTIONNAIRE_RESPONSES = "GET_QUESTIONNAIRE_RESPONSES";
export const GET_QUESTIONNAIRE_RESPONSE_DETAIL = "GET_QUESTIONNAIRE_RESPONSE_DETAIL";
export const UPDATE_QUESTIONNAIRE_RESPONSE = "UPDATE_QUESTIONNAIRE_RESPONSE";

// Notification
export const LOAD_NOTIFICATIONS = "LOAD_NOTIFICATIONS";
export const LOAD_NOTIFICATION = "LOAD_NOTIFICATION";
export const MARK_NOTIFICATION_READ = "MARK_NOTIFICATION_READ";
export const BULK_UPDATE_NOTIFICATIONS = "BULK_UPDATE_NOTIFICATIONS";
export const LOAD_DROPDOWN_NOTIFICATIONS = "LOAD_DROPDOWN_NOTIFICATIONS";
export const LOAD_LAST_SEEN = "LOAD_LAST_SEEN";
export const UPDATE_LAST_SEEN = "UPDATE_LAST_SEEN";

// Subscription Plans
export const LOAD_ALL_SUBSCRIPTION_PLANS = "LOAD_ALL_SUBSCRIPTION_PLANS";
export const LOAD_SUBSCRIPTION_PLAN_BY_ID = "LOAD_SUBSCRIPTION_PLAN_BY_ID";
export const CREATE_SUBSCRIPTION_PLAN = "CREATE_SUBSCRIPTION_PLAN";
export const DELETE_SUBSCRIPTION_PLAN = "DELETE_SUBSCRIPTION_PLAN";
export const UPDATE_SUBSCRIPTION_PLAN = "UPDATE_SUBSCRIPTION_PLAN";
export const CREATE_FREE_PLAN = "CREATE_FREE_PLAN";
export const LOAD_FREE_PLAN = "LOAD_FREE_PLAN";

//Fetch feature access
export const FETCH_DEFAULT_FEATURE_CONFIG = "FETCH_DEFAULT_FEATURE_CONFIG";

//CLOUD STORAGE
export const CONNECT_CLOUD_STORAGE = "CONNECT_CLOUD_STORAGE";
export const GET_CLOUD_STORAGE_FILES = "GET_CLOUD_STORAGE_FILES";
export const GET_CLOUD_STORAGE_ITEMS = "GET_CLOUD_STORAGE_ITEMS";
export const VALIDATE_CLOUD_SELECTION = "VALIDATE_CLOUD_SELECTION";
export const DOWNLOAD_CLOUD_FILE = "DOWNLOAD_CLOUD_FILE";
export const GET_CLOUD_STORAGE_ACCOUNTS = "GET_CLOUD_STORAGE_ACCOUNTS";
export const COMPLETE_CLOUD_STORAGE = "COMPLETE_CLOUD_STORAGE";
export const DISCONNECT_CLOUD_STORAGE = "DISCONNECT_CLOUD_STORAGE";
